import React from 'react';
import {
  setNewPassword,
  setNewCompany,
} from '../../redux/services/reset-password-service/reset-password-service';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reset, touch } from 'redux-form';
import PropTypes from 'prop-types';
import AgentProfileForm from '../../components/agent-profile/agent-profile';

import ProgressIndicator from '../../components/common/progress-indicator/progress-indicator';

export class AgentProfileContainer extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      data: undefined,
      modalOpen: false,
      type: null,
    };
  }

  componentDidMount = () => {
    // console.log('profile container', this.props);
    if (
      this.props.location.state !== undefined &&
      this.props.location.state.data !== undefined
    )
      this.setState({
        resend: true,
        username: this.props.location.state.data.email,
      });
  };

  handleSubmit = values => {
    console.log('handleSubmit-container', values);
    if (values.currPassword !== undefined) {
      this.props.setNewPassword(
        values.currPassword,
        values.passwordConfirm,
        value => {
          if (value) {
            this.props.touch('updatePasswordForm', 'currPassword');
          }
          this.props.reset('updatePasswordForm');
          this.setState({ modalOpen: value });
        },
      );
    } else if (values.companyName !== undefined) {
      const {
        companyName,
        Str,
        str2,
        city,
        state,
        zip,
        phonenumber,
        url,
      } = values;
      let payload = {
        companyName: companyName,
        street: Str,
        streetline2: str2 === undefined || str2 === null ? '' : str2,
        city: city,
        state: state,
        zipCode: zip,
        phoneNumber: phonenumber,
        url: url === undefined || url === null ? ' ' : url,
      };
      this.props.setNewCompany(payload, value => {
        if (!value) {
          this.props.reset('updatePasswordForm');
        }
        this.setState({ modalOpen: value });
      });
      this.setState({ modalOpen: false });
    }
  };

  handleModalClose = e => {
    e.preventDefault();
    console.log(' handleModalClose');
    this.setState({ modalOpen: false });
  };

  handleModalOpen = e => {
    e.preventDefault();
    console.log('type is in handle', e.currentTarget.value, e);
    this.setState({ modalOpen: true, type: e.currentTarget.value });
  };

  handleConfirmSubmit = values => {
    console.log('handleConfirmSubmit', values);
    this.setState({ resend: false });
    this.props.confirmRegistration(this.state.username, values.code);
  };

  handleResendConfirmCode = e => {
    e.preventDefault();
    this.props.resendConfirmationCode(this.state.username);
  };

  handleBack = e => {
    e.preventDefault();
    this.props.history.push('/');
  };

  handleExistingUsers = e => {
    e.preventDefault();
    if (!this.state.resend) {
      this.setState({ resend: true });
    }
  };

  handleConfirmBack = e => {
    e.preventDefault();
    if (this.props.location.state === undefined) {
      this.setState({ resend: true });
    } else if (
      this.props.location.state.data !== undefined &&
      this.props.location.state.data.resend
    ) {
      this.props.history.push('/', {});
    }
  };

  render() {
    if (
      this.props.location.state !== undefined &&
      this.props.location.state.data !== undefined &&
      this.state.data === undefined
    ) {
      this.setState({ data: this.props.location.state.data });
    }
    return this.props.isLoading ? (
      <div>
        <ProgressIndicator />
      </div>
    ) : (
      <React.Fragment>
        <AgentProfileForm
          errors={this.props.error}
          message={this.props.message}
          onSubmit={this.handleSubmit}
          handleBack={this.handleBack.bind(this)}
          handleModalOpen={this.handleModalOpen.bind(this)}
          handleModalClose={this.handleModalClose.bind(this)}
          data={this.props.currentUser}
          modalOpen={this.state.modalOpen}
          type={this.state.type}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  error: state.resetPassReducer.error,
  message: state.resetPassReducer.message,
  currentUser: state.appReducer.currentUser,
});

const mapDispatchToProps = dispatch => ({
  setNewPassword: bindActionCreators(setNewPassword, dispatch),
  setNewCompany: bindActionCreators(setNewCompany, dispatch),
  reset: bindActionCreators(reset, dispatch),
  touch: bindActionCreators(touch, dispatch),
});

AgentProfileContainer.propTypes = {
  error: PropTypes.object,
  location: PropTypes.PropTypes.shape({
    state: PropTypes.PropTypes.shape({
      data: PropTypes.object,
    }),
  }),
  setNewPassword: PropTypes.func,
  setNewCompany: PropTypes.func,
  currentUser: PropTypes.object,
  cognitoUser: PropTypes.object,
  confirmRegistration: PropTypes.func,
  resendConfirmationCode: PropTypes.func,
  history: PropTypes.func,
  isLoading: PropTypes.bool,
  message: PropTypes.string,
  reset: PropTypes.func,
  touch: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AgentProfileContainer);
